"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var IST = __importStar(require("./subTypes"));

var INCOME_NON_EMPLOYMENT_SUB_TYPES = [IST.BUSINESS_PROFESSIONAL_FARM, IST.PROPERTY_RENTAL, IST.INTERESTS_DIVIDENDS_ROYALTIES, IST.FAMILY_SUPPORT, IST.ALIMONY, IST.HOUSEHOLD_CONTRIBUTIONS, IST.OUTSIDE_CONTRIBUTORS, IST.UNEMPLOYMENT, IST.SOCIAL_SECURITY, IST.SUPPLEMENTAL_SECURITY_INCOME, IST.SUPPLEMENTAL_SECURITY_INCOME_FOR_CHILDREN, IST.SOCIAL_SECURITY_DISABILITY_INSURANCE, IST.SNAP, IST.TANF, IST.SECTION_8, IST.LIFELINE_PHONE, IST.LIHEAP, IST.CHIP, IST.DISABILITY, IST.PENSION_RETIREMENT, IST.VA_DISABILITY, IST.OTHER_GOVERNMENT_ASSISTANCE, IST.OTHER];
exports.default = INCOME_NON_EMPLOYMENT_SUB_TYPES;